import { useCurrentStateAndParams } from "@uirouter/react";

import categoryService from "app/common/services/categoryService";

import { extractPrimaryCategoryFromParams } from "../../routes/routeUtils";

export const usePrimaryCategoryObject = () => {
    const { params } = useCurrentStateAndParams();
    const { category } = params;
    const primaryCategory = extractPrimaryCategoryFromParams(category);

    return categoryService.categoryQueryParamToCategoryObject(primaryCategory);
};
